import { featureAtom } from "@sunrise/feature-flags";

export const imdbTagEnabledAtom = featureAtom("imdb-tag-enabled", false, {
  description: `Feature flag to enable IMDB Rating Tag on detail pages.`,
});
